import { render, staticRenderFns } from "./InfoTwitch.vue?vue&type=template&id=195904a7"
import script from "./InfoTwitch.vue?vue&type=script&lang=js"
export * from "./InfoTwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports